"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ReportLisTtable = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledTable = (0, _styles.styled)(_Table.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  };
});
const StyledTableHead = (0, _styles.styled)(_TableHead.default)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    '& th': {
      background: theme.palette.table.header.primary.main,
      color: theme.palette.table.header.primary.contrastText,
      fontSize: theme.typography.fontSize,
      fontWeight: 'normal',
      paddingLeft: theme.spacing(1),
      paddingRight: 0
    }
  };
});
const StyledTableBody = (0, _styles.styled)(_TableBody.default)(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    '& td': {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      fontSize: theme.typography.fontSize
    }
  };
});
const StyledDataRow = (0, _styles.styled)(_TableRow.default)(_ref4 => {
  let {
    theme
  } = _ref4;
  return {
    background: theme.palette.table.body.primary.main,
    '&:nth-of-type(even)': {
      background: theme.palette.table.body.secondary.main
    }
  };
});
const StyledCell = (0, _styles.styled)(_TableCell.default)(() => ({
  whiteSpace: 'pre-line'
}));

/**
 * 訓練実施報告一覧系テーブルコンポーネント
 */
class ReportLisTtable extends _react.default.Component {
  render() {
    const {
      columns,
      rowData,
      createRow,
      listType
    } = this.props;
    const rows = rowData.map((data, index) => {
      return createRow(data, index);
    });
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(StyledTable, null, /*#__PURE__*/_react.default.createElement(StyledTableHead, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, columns.map((column, index) => {
      return /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        key: 'header_' + index,
        width: column.width
      }, column.label);
    }))), /*#__PURE__*/_react.default.createElement(StyledTableBody, null, rowData.map((data, index) => {
      if (listType === 'TASK' || listType === 'TASK_RESULT') {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: index
        }, /*#__PURE__*/_react.default.createElement(StyledDataRow, null, listType === 'TASK' && /*#__PURE__*/_react.default.createElement(StyledCell, null, rows[index].deleteIcon), /*#__PURE__*/_react.default.createElement(StyledCell, null, rows[index].bumon), /*#__PURE__*/_react.default.createElement(StyledCell, null, rows[index].kind), /*#__PURE__*/_react.default.createElement(StyledCell, null, rows[index].taio), /*#__PURE__*/_react.default.createElement(StyledCell, null, rows[index].schedule), /*#__PURE__*/_react.default.createElement(StyledCell, null, rows[index].task)));
      } else {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: index
        }, /*#__PURE__*/_react.default.createElement(StyledDataRow, null, /*#__PURE__*/_react.default.createElement(StyledCell, null, rows[index].teamName), /*#__PURE__*/_react.default.createElement(StyledCell, null, rows[index].replyNum), /*#__PURE__*/_react.default.createElement(StyledCell, null, rows[index].understand), /*#__PURE__*/_react.default.createElement(StyledCell, null, rows[index].effect), /*#__PURE__*/_react.default.createElement(StyledCell, null, rows[index].teamComment)));
      }
    }))));
  }
}
exports.ReportLisTtable = ReportLisTtable;
var _default = exports.default = (0, _reactIntl.injectIntl)(ReportLisTtable);